module.exports = function(successCallback, errorCallback) {
	require.ensure([], function() {
		successCallback(require("!!../../../../node_modules/babel-loader/lib/index.js!./PaypalAfterPayment.js"));
	}, function() {
		if (errorCallback) errorCallback.apply(this, arguments);
	});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/split-chunk-loader?lazy!./src/Checkout/ShippingAndPayment/Paypal/PaypalAfterPayment.js
// module id = 1176
// module chunks = 58